import {Route, Switch} from 'react-router-dom';

import NotFound from 'pages/NotFound';

import General from './General';

const Create = () => {
  return (
    <Switch>
      <Route exact path="/b/create" component={General} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default Create;
